import { Routes } from '@angular/router';
import { HomeComponent } from './containers/home/home.component';
import { AboutComponent } from './containers/about/about.component';
import { ContactComponent } from './containers/contact/contact.component';
import { EcoComponent } from './containers/eco/eco.component';
import { OffersComponent } from './containers/offers/offers.component';
import { ReferencesComponent } from './containers/references/references.component';
import { NotFoundComponent } from './containers/not-found/not-found.component';

export const routes: Routes = [
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  { path: 'home', component: HomeComponent },
  { path: 'about', component: AboutComponent },
  { path: 'contact', component: ContactComponent },
  { path: 'offers', component: OffersComponent },
  { path: 'references', component: ReferencesComponent },
  { path: 'policy', component: EcoComponent },
  { path: '404', component: NotFoundComponent },
  { path: '**', redirectTo: '/404' },
];
